import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import { Button } from './Button/index.js';
import { ModalHeader } from './ModalHeader.js';
import { i18n } from '../i18n/translate.js';
var RULE_SET_BUTTONS = Object.freeze([{
  ruleSet: 'he_admin',
  label: i18n.t('Higher Education Students')
}, {
  ruleSet: 'fac_staff_admin',
  label: i18n.t('Faculty & Staff')
}, {
  ruleSet: 'cc_admin',
  label: i18n.t('Employees')
}, {
  ruleSet: 'scorm_manager',
  label: i18n.t('Scorm')
}]);
var RuleSetModal = function RuleSetModal(_ref) {
  var container = _ref.container,
    href = _ref.href,
    onCancel = _ref.onCancel,
    _ref$ruleSets = _ref.ruleSets,
    ruleSets = _ref$ruleSets === void 0 ? [] : _ref$ruleSets,
    show = _ref.show;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    ruleSet = _useState2[0],
    setRuleSet = _useState2[1];
  var _useState3 = useState(container),
    _useState4 = _slicedToArray(_useState3, 2),
    containerElem = _useState4[0],
    setContainerElem = _useState4[1];
  var isCancelable = !!onCancel;
  var ruleSetButtons = RULE_SET_BUTTONS.filter(function (ruleSetButton) {
    return ruleSets.includes(ruleSetButton.ruleSet);
  });
  useEffect(function () {
    // we need to do this in useEffect since this component is rendered server-side, making document object not available
    if (!containerElem) {
      setContainerElem(document.querySelector('body'));
    }
  }, [containerElem]);
  if (!containerElem || ruleSetButtons.length < 2) return null;
  var handleOnCancel = function handleOnCancel() {
    setRuleSet();
    onCancel();
  };
  var getRedirectHref = function getRedirectHref() {
    var url = href.split('#');
    url[0] += "?current_rule_set_name=".concat(ruleSet);
    return url.join('#');
  };
  return /*#__PURE__*/React.createElement(Modal, {
    animation: false,
    "aria-labelledby": "rule-set-modal-title",
    className: "rule-set-modal modal-size-small",
    dialogClassName: "foundry",
    id: "rule-set-modal",
    show: show,
    container: containerElem
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    canClickOff: isCancelable,
    className: "rule-set-modal-title",
    closeButton: false,
    description: i18n.t('Select the population you are here to train or the admin settings you would like to manage.'),
    onCancel: handleOnCancel,
    title: i18n.t('Select a Population'),
    titleId: "rule-set-modal-title"
  }), /*#__PURE__*/React.createElement(Modal.Body, null, ruleSetButtons.map(function (_ref2) {
    var rs = _ref2.ruleSet,
      label = _ref2.label;
    return /*#__PURE__*/React.createElement(Button, {
      key: rs,
      block: true,
      "data-object-type": "reports",
      "data-action": "select-population",
      "data-object-id": rs,
      className: "large".concat(rs === ruleSet ? ' selected' : ''),
      label: label,
      onClick: function onClick() {
        return setRuleSet(rs);
      },
      style: "pill",
      renderAsLegacy: true
    });
  })), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    block: true,
    className: "large",
    disabled: !ruleSet,
    href: getRedirectHref(),
    "data-object-type": "reports-navigation",
    "data-action": "select-population-next",
    label: i18n.t('Next'),
    style: "primary",
    renderAsLegacy: true
  }), isCancelable && /*#__PURE__*/React.createElement(Button, {
    block: true,
    label: i18n.t('Cancel'),
    "data-object-type": "reports-navigation",
    "data-action": "select-population-cancel",
    onClick: handleOnCancel,
    style: "link",
    renderAsLegacy: true
  })));
};
RuleSetModal.displayName = "RuleSetModal";
RuleSetModal.propTypes = {
  container: PropTypes.node,
  href: PropTypes.string,
  onCancel: PropTypes.func,
  ruleSets: PropTypes.array,
  show: PropTypes.bool
};
export { RuleSetModal };